import { sectors as actionTypes } from '$constants/action-types';

export const fetchAll = () => ({
  type: actionTypes.FETCH_ALL
});

export const fetchAllSuccess = result => ({
  type: actionTypes.FETCH_ALL_SUCCESS,
  result
});



// WEBPACK FOOTER //
// ./src/actions/sectors.js